import { render, staticRenderFns } from "./AbatementCostByMethodDetail.vue?vue&type=template&id=25f9ab29"
import script from "./AbatementCostByMethodDetail.vue?vue&type=script&lang=js"
export * from "./AbatementCostByMethodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports